import React from "react";

export const TooltipWrapper = React.forwardRef(function Wrapper(
  props: any,
  ref
) {
  //  Spread the props to the underlying DOM element.
  return <span {...props} ref={ref} />;
});
